module.exports = __webpack_public_path__ + "static/media/visitor.c2bc2478.jpg";